import React, { useState } from "react";
// Sabhi icons ko 'fa' se import kiya hai for stability
import { 
  FaCheckCircle, 
  FaPlus, 
  FaMinus, 
  FaTruck, 
  FaLeaf, 
  FaGlassMartiniAlt 
} from "react-icons/fa"; 
import "./MilkSection.css";

const MilkSection = () => {
  const images = ["/product1.jpeg", "/product2.jpeg", "/product1.jpeg", "/product2.jpeg"];
  const [mainImage, setMainImage] = useState(images[0]);
  const [activeLitre, setActiveLitre] = useState("1L");
  const [activeType, setActiveType] = useState("Farm Fresh");
  const [quantity, setQuantity] = useState(1);

  const increment = () => setQuantity(prev => prev + 1);
  const decrement = () => setQuantity(prev => (prev > 1 ? prev - 1 : 1));

  return (
    <section id="product" className="milk-section py-5">
      <div className="container">
        <div className="row g-lg-5 g-4 align-items-center">
          
          {/* Left: Interactive Gallery */}
          <div className="col-lg-6">
            <div className="gallery-container">
              <div className="badge-premium">
                <FaLeaf className="me-1"/> 100% Organic
              </div>
              <div className="main-display shadow-lg">
                <img src={mainImage} alt="A2 Milk" className="img-fluid main-img-zoom" />
              </div>
              <div className="thumbnail-track">
                {images.map((img, i) => (
                  <div 
                    key={i} 
                    className={`thumb-box ${mainImage === img ? "active-thumb" : ""}`}
                    onClick={() => setMainImage(img)}
                  >
                    <img src={img} alt={`Milk thumb ${i}`} />
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Right: Premium Product Info */}
          <div className="col-lg-6">
            <div className="product-info-wrapper">
              <div className="brand-header">
                <h1 className="brand-title">Gaubliiss <span className="gold-gradient">A2 Cow Milk</span></h1>
                <div className="status-tag">
                  <FaCheckCircle className="me-2 text-success"/> In Stock - Farm to Home
                </div>
              </div>
              
              <p className="description-text">
                Pure A2 protein milk from native cows. Rich in nutrients, Vitamin D, and Calcium. 
                Delivered in sterilised <strong>Glass Bottles</strong> to maintain 100% purity.
              </p>

              <div className="feature-pills-row">
                <span className="feature-pill"><FaTruck /> Fast Delivery</span>
                <span className="feature-pill"><FaGlassMartiniAlt /> Glass Bottle</span>
              </div>

              <hr className="divider-line" />

              <div className="selection-stack">
                {/* Quantity selection */}
                <div className="select-group">
                  <label className="group-label">Choose Quantity</label>
                  <div className="pill-container">
                    {[ "1L", "2L"].map(size => (
                      <button 
                        key={size}
                        className={`pill-btn ${activeLitre === size ? "active" : ""}`}
                        onClick={() => setActiveLitre(size)}
                      >
                        {size}
                      </button>
                    ))}
                  </div>
                </div>

                {/* Variant selection */}
                <div className="select-group">
                  <label className="group-label">Select Variant</label>
                  <div className="pill-container">
                    {["Farm Fresh", "Pasteurized"].map(type => (
                      <button 
                        key={type}
                        className={`pill-btn ${activeType === type ? "active" : ""}`}
                        onClick={() => setActiveType(type)}
                      >
                        {type}
                      </button>
                    ))}
                  </div>
                </div>

                {/* Schedule & Stepper */}
                <div className="row g-3 align-items-end mt-2">
                  <div className="col-md-7">
                    <label className="group-label">Delivery Schedule</label>
                    <select className="minimal-select">
                      <option>Daily (Morning)</option>
                      <option>Alternate Days</option>
                      <option>Custom Plan</option>
                    </select>
                  </div>
                  <div className="col-md-5">
                    <label className="group-label">Daily Bottles</label>
                    <div className="quantity-stepper">
                      <button onClick={decrement} type="button"><FaMinus /></button>
                      <span className="qty-val">{quantity}</span>
                      <button onClick={increment} type="button"><FaPlus /></button>
                    </div>
                  </div>
                </div>
              </div>

              <button className="cta-button-gold mt-4">
                Confirm Interest
              </button>
              
              <div className="location-info">
                <p className="location-note">
                  📍 Currently delivering across <strong>Noida & Greater Noida</strong>
                </p>
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default MilkSection;